import { Component, Input } from '@angular/core';
import { DatePickerComponent } from '@spartacus/storefront';
import { ICON_TYPE } from "../../icons/icon.model";

@Component({
  selector: 'app-date-picker',
  templateUrl: './custom-date-picker.component.html',
  standalone: false
})
export class CustomDatePickerComponent extends DatePickerComponent {

  iconType = ICON_TYPE;

  keyDown(event: any): void {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 8 || charCode === 11) {
      return;
    }

    const checkNumbers = this.numberOnly(charCode);
    if (checkNumbers) {
      if (event?.target?.value) {
        const validateDate = event?.target?.value.split('-');
        if (validateDate?.length) {
          const years = validateDate[0];
          if (parseInt(years, 0) > 999) {
            if (event?.target?.value?.length >= 10) {
              event.preventDefault();
            }
          }
        }
      }
    }
  }

  numberOnly(charCode): boolean {
    if ((charCode >= 37 && charCode <= 40)) {
      return false;
    }
    return (charCode > 31 && (charCode < 48 || charCode > 57));
  }
}
